import winston from 'winston';

import { DatadogTransport } from './datadog.transport';

import { getRuntimeEnvironment } from '@/environment/get-runtime-environment';
import { RuntimeEnvironment } from '@/environment/runtime-environment';

export const rootLogger = winston.createLogger({
  level: process.env.LOG_LEVEL || 'INFO',
  format: winston.format.combine(
    winston.format.errors({ stack: true }),
    winston.format.timestamp(),
    winston.format.json(),
  ),
  transports: [
    new winston.transports.Console(),
  ],
});

if ((typeof window) !== 'undefined' && getRuntimeEnvironment(window.location.origin) === RuntimeEnvironment.PRD) {
  rootLogger.add(
    new DatadogTransport({ level: process.env.LOG_LEVEL || 'INFO' }),
  );
}
